import { render } from "./CarFleet.vue?vue&type=template&id=b992cb20"
import script from "./CarFleet.vue?vue&type=script&lang=js"
export * from "./CarFleet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__